import { gql } from '@apollo/client';

export const GENERATE_INVOICE = gql`
  mutation GenerateInvoice($input: InvoiceInput!) {
    generateInvoice(input: $input) # Returns Base64 String!
  }
`;

export const DELETE_INVOICE = gql`
  mutation DeleteInvoice($id: UUID!) {
    deleteInvoice(id: $id)
  }
`;

export const EMPTY_INVOICE_STORAGE = gql`
  mutation EmptyInvoiceFolder {
    emptyInvoiceFolder
  }
`;

export const UPDATE_INVOICE_PAID_STATUS = gql`
  mutation UpdateInvoicePaidStatus($id: UUID!) {
    updateInvoicePaidStatus(id: $id)
  }
`;

export const UPDATE_INVOICE_STATUS = gql`
  mutation UpdateInvoiceStatus($id: UUID!, $status: InvoiceStatus!) {
    updateInvoiceStatus(id: $id, status: $status)
  }
`;

export const SEND_INVOICE_EMAIL = gql`
  mutation SendInvoiceEmail($invoiceId: UUID!, $email: String) {
    sendInvoiceEmail(invoiceId: $invoiceId, email: $email)
  }
`;

export const CREATE_RECURRING_INVOICE = gql`
  mutation CreateRecurringInvoice($input: RecurringInvoiceInput!) {
    createRecurringInvoice(input: $input) {
      id
      customerName
      frequency
      nextRunDate
      isActive
    }
  }
`;

export const DELETE_RECURRING_INVOICE = gql`
  mutation DeleteRecurringInvoice($id: UUID!) {
    deleteRecurringInvoice(id: $id)
  }
`;

export const GENERATE_DUE_RECURRING_INVOICES = gql`
  mutation GenerateDueRecurringInvoices {
    generateDueRecurringInvoices
  }
`;

export const UPDATE_INVOICE = gql`
  mutation UpdateInvoice($id: UUID!, $input: UpdateInvoiceInput!) {
    updateInvoice(id: $id, input: $input)
  }
`;

export const UPDATE_RECURRING_INVOICE = gql`
  mutation UpdateRecurringInvoice($id: UUID!, $input: RecurringInvoiceInput!) {
    updateRecurringInvoice(id: $id, input: $input)
  }
`;

export const UPDATE_SETTINGS = gql`
  mutation UpdateSettings($input: UpdateSettingsInput!) {
    updateSettings(input: $input) {
      companyName
      address
      phone
      abn
      defaultHourlyRate
      defaultDailyRate
      defaultTaxRate
      paymentTermsDays
      invoiceNumberPrefix
      emailFromName
      emailReplyTo
      defaultBillingMode
      updatedAt
    }
  }
`;
